
import { Form , Field, ChildForm } from '../form/form';
import { FormData } from '../form/formData';
import { SelectOption, Vo } from '../form/types';
import { Validators } from '@angular/forms'
import { ServiceAgent} from '../form/serviceAgent';

export class SeasonsListForm extends Form {
	private static _instance = new SeasonsListForm();
	seasonId:Field = {
		name:'seasonId'
		,controlType: 'Dropdown'
		,label: 'Select a Season'
		,isRequired: true
		,listName: 'seasonList'
		,valueType: 1
		,errorId: 'invalidId'
		,maxValue: 9999999999999
	};

	public static getInstance(): SeasonsListForm {
		return SeasonsListForm._instance;
	}

	constructor() {
		super();
		this.fields = new Map();
		this.controls = new Map();
		this.controls.set('seasonId', [Validators.required, Validators.max(9999999999999)]);
		this.fields.set('seasonId', this.seasonId);
		this.listFields = ['seasonId'];
	}

	public getName(): string {
		 return 'seasonsList';
	}
}


export class SeasonsListFd extends FormData {
	constructor(form: SeasonsListForm, sa: ServiceAgent) {
		super(form, sa);
	}

	setFieldValue(name: 'seasonId', value: string | number | boolean | null ): void {
		super.setFieldValue(name, value);
	}

	getFieldValue(name: 'seasonId' ): string | number | boolean | null {
		return super.getFieldValue(name);
	}
}


export interface SeasonsListVo extends Vo {
	seasonId?: number
}
